<template>
    <van-popup v-model:show="show" @click-overlay="close" position="center" :style="{
        minWidth: '70%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        zIndex: '10000'
    }">
        <div class="popupContainer">
            <div class="closeIcon">
                <img src="@/assets/common/close_icon.png" alt="" @click="close">
            </div>
            <div class="bannerImg">
                <img src="@/assets/common/pwa_update_banner.png" alt="">
            </div>
            <div style="padding: 0 20px;">
                <div class="detailsBg">
                    <div class="infoText">
                        {{ title }}
                    </div>
                </div>

            </div>

        </div>

    </van-popup>
    <ContactServicePopup ref="contactRef" />
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { ref, defineExpose } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import ContactServicePopup from '../../profile/contactServicePopup.vue';
import { useUserStore } from '@/stores/user';
const userStore = useUserStore()
const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const title = ref('')
const contactRef = ref()

const open = (value: string) => {
    show.value = true
    title.value = value
}


const close = () => {
    show.value = false
    contactRef.value.close()
    userStore.setPwaShowing(false)
}


defineExpose({
    open,
    close
})
</script>
<style scoped>
.popupContainer {
    background-image: linear-gradient(147deg, #FEFCE1 0%, #DA8D4E 100%);
    padding: 10px;
    border-radius: 25px;
    width: 70%;
    overflow: hidden;
}

.van-overlay {
    z-index: 9999 !important;
}

.closeIcon {
    display: flex;
    justify-content: right;
}

.closeIcon img {
    width: 25px;
    padding: 2px;
    background-color: #000;
    border-radius: 30px;
}

.bannerImg {
    padding: 5px;
}

.bannerImg img {
    width: 100%;
}

.detailsBg {
    background: url('@/assets/common/pwa_update_background1.png');
    background-size: cover;
    background-repeat: repeat;
    border: 2px solid #f7d9b5;
    border-radius: 10px;
    margin-bottom: 15px;
    padding: 15px 10px;
}

.infoText {
    display: flex;
    justify-content: center;
    color: #c92222;
    font-size: 16px;
    padding: 5px;
    font-weight: bold;
}

.bonusBar {
    background: #00000014;
    color: #000000a6;
    border-radius: 30px;
    padding: 15px;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
}

.bonusBar span {
    color: #7800BB;
    font-size: 17px;
}

.bonusBar img {
    width: 25px;
    padding-right: 10px;
}

.linkBtn {
    background-image: linear-gradient(180deg, #F39A4F 0%, #78340F 100%);
    border: 1.5px solid rgba(249, 196, 134, 1);
    padding: 15px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    color: #FFFFFF;
    font-size: 15px;
    width: 90%;
}

.linkBtn img {
    width: 25px;
    padding-right: 10px;
}

.serviceIcon {
    display: flex;
    justify-content: center;
    align-items: center;
}

.serviceIcon img {
    width: 40%;
    padding: 12px;
    border-radius: 30px;
    background: #00000040;
}

.alignment {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>